import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SearchIcon, ReceiptIcon, UserIcon, LogOutIcon, MenuIcon, GlobeIcon, CheckIcon, ClockIcon, BookmarkIcon, BellIcon, ZapIcon } from './Icons';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const NavItem = ({ to, icon, label, badge, end, onClick }) => (
  <NavLink to={to} end={end} className={({isActive})=>`nav-item${isActive?' active':''}`} onClick={onClick}>
    <span className="nav-icon">{icon}</span>
    {label}
    {badge != null && badge > 0 && <span className="nav-badge">{badge > 9 ? '9+' : badge}</span>}
  </NavLink>
);

export default function SidebarCliente() {
  const navigate = useNavigate();
  const { utilizador, logout, actualizarUtilizador } = useAuth();
  const [open,         setOpen]        = useState(false);
  const [naoLidas,     setNaoLidas]    = useState(0);
  const [chatNaoLidas, setChatNaoLidas]= useState(0);
  const [ativando,     setAtivando]    = useState(false);
  const [erroAtiv,     setErroAtiv]    = useState('');
  const close = () => setOpen(false);

  useEffect(() => {
    const tk = localStorage.getItem('kialuga_token');
    if (!tk) return;
    fetch(`${BASE}/notificacoes`, { headers: { Authorization: `Bearer ${tk}` } })
      .then(r => r.json())
      .then(d => { if (d.sucesso) setNaoLidas(d.notificacoes.filter(n => !n.lida).length); })
      .catch(() => {});
    fetch(`${BASE}/chat/nao-lidas/count`, { headers: { Authorization: `Bearer ${tk}` } })
      .then(r => r.json())
      .then(d => { if (d.sucesso) setChatNaoLidas(d.nao_lidas); })
      .catch(() => {});
  }, []);

  const ativarFornecedor = async () => {
    setAtivando(true);
    setErroAtiv('');
    try {
      const tk = localStorage.getItem('kialuga_token');
      const r  = await fetch(`${BASE}/perfil/ativar-fornecedor`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${tk}`, 'Content-Type': 'application/json' },
      });
      const d = await r.json();
      if (d.sucesso) {
        actualizarUtilizador({ pode_fornecer: true });
        close();
        navigate('/fornecedor');
      } else {
        setErroAtiv(d.mensagem || 'Erro ao activar');
      }
    } catch(e) {
      setErroAtiv('Erro de ligação');
    } finally {
      setAtivando(false);
    }
  };

  const podeFornecer = utilizador?.pode_fornecer || utilizador?.tipo === 'fornecedor';

  return (
    <>
      <div className={`sidebar-overlay${open?' show':''}`} onClick={close}/>
      <button className="sidebar-toggle" onClick={()=>setOpen(true)} style={{position:'fixed',top:'8px',left:'12px',zIndex:60}}>
        <MenuIcon size={18}/>
      </button>

      <div className={`sidebar${open?' open':''}`}>
        <div className="sidebar-logo">
          <div className="logo-mark">
            <div className="logo-k">K</div>
            <div>
              <div className="logo-text">KiAluga</div>
              <div className="logo-sub">Área do Cliente</div>
            </div>
          </div>
        </div>

        <div className="sidebar-nav">
          <div className="nav-section">Explorar</div>
          <NavItem to="/cliente"           icon={<SearchIcon   size={16}/>}  label="Descobrir produtos" end onClick={close}/>
          <NavItem to="/cliente/reservas"  icon={<ReceiptIcon  size={16}/>}  label="As minhas reservas" badge={chatNaoLidas||undefined} onClick={close}/>
          <NavItem to="/cliente/favoritos" icon={<BookmarkIcon size={16}/>}  label="Favoritos"          onClick={close}/>
          <NavItem to="/notificacoes"      icon={<BellIcon     size={16}/>}  label="Notificações" badge={naoLidas} onClick={close}/>

          <div className="nav-section">Conta</div>
          <NavItem to="/perfil" icon={<UserIcon size={16}/>} label="O meu perfil" onClick={close}/>
          <div className="nav-item" onClick={()=>{close();navigate('/');}}>
            <span className="nav-icon"><GlobeIcon size={16}/></span> Página inicial
          </div>

          {/* ── Modo Fornecedor ── */}
          <div className="nav-section">Fornecedor</div>
          {podeFornecer ? (
            <div className="nav-item"
              style={{color:'var(--orange)',fontWeight:'600'}}
              onClick={()=>{ close(); navigate('/fornecedor'); }}>
              <span className="nav-icon"><ZapIcon size={16} color='var(--orange)'/></span>
              Mudar para Fornecedor
            </div>
          ) : (
            <>
              <div
                className="nav-item"
                style={{color: ativando ? 'var(--text-muted)' : 'var(--text-secondary)', cursor: ativando ? 'wait' : 'pointer'}}
                onClick={ativando ? undefined : ativarFornecedor}>
                <span className="nav-icon"><ZapIcon size={16}/></span>
                {ativando ? 'A activar...' : 'Activar modo fornecedor'}
              </div>
              {erroAtiv && (
                <div style={{fontSize:'11px',color:'var(--danger)',padding:'0 14px 6px',lineHeight:'1.4'}}>
                  {erroAtiv}
                </div>
              )}
            </>
          )}

          <div className="nav-item" style={{color:'rgba(239,68,68,0.7)'}} onClick={()=>{logout();navigate('/');}}>
            <span className="nav-icon"><LogOutIcon size={16}/></span> Sair da conta
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="user-card">
            <div className="avatar" style={{overflow:'hidden'}}>
              {utilizador?.foto_url
                ? <img src={utilizador.foto_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                : (utilizador?.nome||'?')[0].toUpperCase()
              }
            </div>
            <div className="user-info">
              <div className="user-name">{utilizador?.nome||'Cliente'}</div>
              <div className="user-role" style={{display:'flex',alignItems:'center',gap:'4px'}}>
                {utilizador?.kyc_estado==='verificado'
                  ? <><CheckIcon size={11} color='var(--success)'/> Verificado</>
                  : <><ClockIcon size={11}/> Pendente verificação</>
                }
                {podeFornecer && (
                  <span style={{marginLeft:'4px',fontSize:'9px',background:'var(--orange)',color:'#fff',
                    borderRadius:'4px',padding:'1px 5px',fontWeight:'700',letterSpacing:'0.3px'}}>
                    +F
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom Navigation (mobile only) ── */}
      <nav className="bottom-nav" aria-label="Navegação principal">
        <div className="bottom-nav-inner">
          <NavLink to="/cliente" end className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <SearchIcon size={22}/>
            <span>Descobrir</span>
          </NavLink>
          <NavLink to="/cliente/reservas" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <ReceiptIcon size={22}/>
            <span>Reservas</span>
            {chatNaoLidas > 0 && <span className="bottom-nav-badge">{chatNaoLidas > 9 ? '9+' : chatNaoLidas}</span>}
          </NavLink>
          <NavLink to="/cliente/favoritos" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <BookmarkIcon size={22}/>
            <span>Favoritos</span>
          </NavLink>
          <NavLink to="/notificacoes" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <BellIcon size={22}/>
            <span>Notificações</span>
            {naoLidas > 0 && <span className="bottom-nav-badge">{naoLidas > 9 ? '9+' : naoLidas}</span>}
          </NavLink>
          <NavLink to="/perfil" className={({isActive})=>`bottom-nav-item${isActive?' active':''}`}>
            <UserIcon size={22}/>
            <span>Perfil</span>
          </NavLink>
        </div>
      </nav>
    </>
  );
}
